import { instance as axios } from "./baseUrl";

export const login = (user) => axios.post("/security/login", { ...user });

export const logout = () => axios.post("/security/logout");

export const validateRegisterIsApi = (userIs) =>
  axios.post("security/email/confirm", { ...userIs });

export const validateRegisterPsApi = (userIs) =>
  axios.post("security/email/confirm", { ...userIs });

export const validateRegisterCsApi = (userIs) =>
  axios.post("security/email/confirm", { ...userIs });

export const confirmationRegisterIsApi = (userIs) =>
  axios.post("security/student/password", { ...userIs });

export const resettingPasswordApi = (values) => {
  return axios.post("/forgot_password/" + values.token, { ...values }, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getMe = (config = {}) =>
  axios.get("me", config);

export const registerFast = (userData) =>
  axios.post("/security/register/fast", userData);

export const registerClassic = (userData) =>
  axios.post("/security/register/student/classic", userData);

export const registerStudent = (userData) =>
  axios.post("/security/register/student", userData);

/**
 * Crée une connexion SSE pour écouter la validation d'email en temps réel
 * @param {string} contractReference - Référence du contrat pour identifier l'utilisateur
 * @param {Object} callbacks - { onMessage, onError, onOpen }
 * @returns {EventSource} L'instance EventSource pour pouvoir la fermer plus tard
 */
export const createEmailConfirmationStream = (contractReference, callbacks = {}) => {
  const { onMessage, onError, onOpen } = callbacks;

  // Construire l'URL SSE
  const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
  const sseUrl = `${baseUrl}/api/email-confirmation/stream?contractReference=${contractReference}`;

  console.log('🔌 Création connexion SSE:', sseUrl);

  // Créer l'EventSource avec credentials pour les cookies
  const eventSource = new EventSource(sseUrl, {
    withCredentials: true,
  });

  // Callback quand la connexion est établie
  if (onOpen) {
    eventSource.onopen = () => {
      console.log('✅ Connexion SSE établie');
      onOpen();
    };
  }

  // Callback pour les messages reçus
  eventSource.onmessage = (event) => {
    console.log('📨 Message SSE reçu:', event.data);

    try {
      const data = JSON.parse(event.data);
      if (onMessage) {
        onMessage(data);
      }
    } catch (err) {
      console.error('❌ Erreur parsing message SSE:', err);
    }
  };

  // Callback pour les erreurs
  eventSource.onerror = (error) => {
    console.error('❌ Erreur SSE:', error);
    if (onError) {
      onError(error);
    }
  };

  return eventSource;
};